interface WithPresentationName {
  displayName: string
  presentation?: { name?: string | null } | null
}

interface WithPresentationImage {
  image?: string | null
  presentation?: { image?: string | null } | null
}

/**
 * Returns the guest-facing name: presentation override if set, otherwise displayName.
 * @param resource
 */
export const getDisplayName = <T extends WithPresentationName>(
  resource: T
): string => resource.presentation?.name ?? resource.displayName

/**
 * Returns the guest-facing image: presentation override if set, otherwise native image.
 * @param resource
 */
export const getDisplayImage = <T extends WithPresentationImage>(
  resource: T
): string | null | undefined => resource.presentation?.image ?? resource.image

interface WithPresentation {
  presentation?: Record<string, unknown> | null
}

/**
 * Whether a resource has any non-empty presentation overrides.
 * Returns false for null, undefined, or empty `{}` presentation objects.
 * @param resource
 */
export const hasPresentation = <T extends WithPresentation>(
  resource: T
): boolean => {
  if (!resource.presentation) return false

  return Object.values(resource.presentation).some(
    (v) => v !== null && v !== undefined && v !== ''
  )
}
